import HomeBanner from "../images/feature-banner.png";
import React, { Component } from "react";
import { useState } from "react";
import axios from "axios";
import { useEffect } from "react";

export default function TermsCondition() {
  const [staticContent, setStaticContent] = useState({});

  useEffect(()=>{
    getTermsAndCondition()
  }, [])

  const getTermsAndCondition = async() => {
    await axios
      .get(process.env.REACT_APP_API_KEY + "api/get-static-content/"+localStorage.getItem("selectLang")+"?key=TermsAndCondition",
      {
        headers: {
        "Content-type": "Application/json"
        }   
      }).then(function (response) {  
        
        console.log("response.data =>", response);
        setStaticContent({
            subject:response.data.data.subject,
            content:response.data.data.content
          });
      }).catch(function (error) {        
        console.log("error =>", error);
      });

  }

  return (
    <>
    <div className="TC-banner">
      <img src={HomeBanner} alt="" />
    </div>
    <div className="TC-Text-container">
    <div className="TC-Textbox">
        <h1>{staticContent.subject}</h1>
        <div dangerouslySetInnerHTML={{__html: staticContent.content}} className="main" ></div>

    </div>
    </div>
    </>
  );
}
